import FaqList from '../components/FaqList';
import SectionHeader from '../components/SectionHeader';
import Seo from '../components/Seo';
import { pageIntros } from '../data/site';

export default function FAQ() {
  return (
    <>
      <Seo
        title="FAQ"
        description="Frequently asked questions about DropBridge, supplier product drafting, Shopify publishing, and markup controls."
        path="/faq"
      />
      <section className="pb-8 pt-32">
        <div className="container-page">
          <SectionHeader {...pageIntros.faq} />
        </div>
      </section>
      <FaqList showHeader={false} />
    </>
  );
}
